import cn from 'classnames';
import React from 'react';

import { isCustomAuth } from '../../../../experiments/customAuth/utils';
import { UniversalCart } from '../../../../scripts/blocks/store/cart/UniversalCart';
import { SelectorListItem } from '../../../../types/store/selector-list-item';
import AddToCartButton from './AddToCartButton/AddToCartButton';
import BuyButton from './BuyButton';
import GoToCheckoutButton from './GoToCheckoutButton';

import { FiveSymbolLocale } from '#common/types/locale';

interface IStoreButtonsProps {
  className?: string;
  buttonId: string;
  isForVc?: boolean;
  isPreOrder?: boolean;
  requireAuth?: boolean;
  type: string;
  sku: string;
  buttonText: string;
  isTextNeeded?: boolean;
  selectorList: SelectorListItem[];
  cart: UniversalCart;
  locale: FiveSymbolLocale;
  enableCart?: boolean;
  vcSku?: string;
  xaElementValue?: string;
  xaExtra?: string;
  buttonsClassPrefix?: string;
  addToCart?: (sky?: string) => void;
  section?: 'pop-up';
  closeBundleInfoModal: (sku: string) => void;
}

const StoreButtons: React.FC<IStoreButtonsProps> = ({
  className,
  buttonId,
  isForVc,
  isPreOrder,
  requireAuth,
  vcSku,
  type,
  sku,
  xaElementValue,
  xaExtra,
  buttonText,
  enableCart,
  cart,
  selectorList,
  isTextNeeded,
  locale,
  buttonsClassPrefix,
  addToCart,
  section,
  closeBundleInfoModal,
}: IStoreButtonsProps) => {
  const isShowOpenerButton = !isCustomAuth() && cart?.hasSKU?.(sku);

  return (
    <div
      className={cn(
        'store__btn-block',
        {
          'store__btn-block--with-cart': enableCart,
        },
        { [`${className}`]: className !== '' }
      )}
      data-type='store-buttons'
    >
      <BuyButton
        id={buttonId}
        isForVc={isForVc}
        isPreOrder={isPreOrder}
        requireAuth={requireAuth}
        vcSku={vcSku}
        type={type}
        sku={sku}
        xaElementValue={xaElementValue}
        xaExtra={xaExtra}
        text={buttonText}
        hidden={isShowOpenerButton}
        buttonClassPrefix={buttonsClassPrefix}
      />
      {!isForVc && enableCart && (
        <AddToCartButton
          sku={sku}
          locale={locale}
          isTextNeeded={isTextNeeded}
          addToCart={addToCart || (() => {})}
          hidden={isShowOpenerButton}
          selectorList={selectorList}
          buttonClassPrefix={buttonsClassPrefix}
          section={section}
        />
      )}
      <GoToCheckoutButton
        sku={sku}
        cart={cart}
        locale={locale}
        hidden={!isShowOpenerButton}
        buttonClassPrefix={buttonsClassPrefix}
        section={section}
        closeBundleInfoModal={closeBundleInfoModal}
      />
    </div>
  );
};

export default StoreButtons;
